import { PopupModal } from "../constants/popupModal";
export default function showPopupModal(show, children) {
    return {
        type: show ? PopupModal.Show : PopupModal.Hide,
        payload: children
    };
}
